import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { Layout, Spin, Icon } from 'antd';
import { Link, withRouter } from 'react-router-dom';
import {
    Title, Tabs, SideBar, PanelLayout
} from '../../components';
import ObjectsDetail from './components/objects';

import cn from '../../utils/cn';

import './style.less';

const { PanelHeader, PanelFooter, PanelContent } = PanelLayout;

@withTranslation('harmful objects')
@cn('pesticides')
export default class Pesticides extends Component {
    render() {
        const { cn } = this;

        const { t, history } = this.props;

        return (
            <Layout className={cn()}>
                {/* <SideBar /> */}
                <PanelLayout>
                    <PanelHeader>
                        <Title title={t('title')} />
                    </PanelHeader>
                    <PanelContent>
                        <ObjectsDetail />
                    </PanelContent>
                </PanelLayout>
            </Layout>
        );
    }
}